import { render, staticRenderFns } from "./small-box.vue?vue&type=template&id=cc385968&scoped=true&"
import script from "./small-box.vue?vue&type=script&lang=js&"
export * from "./small-box.vue?vue&type=script&lang=js&"
import style0 from "./small-box.vue?vue&type=style&index=0&id=cc385968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc385968",
  null
  
)

export default component.exports